import { IconButton, IconButtonProps } from '@chakra-ui/react';
import COLORS from 'constants/colors';

export const AppIconButton = (props: IconButtonProps) => {
  return (
    <IconButton
      size="xs"
      boxSize="24px"
      minWidth="auto"
      zIndex={1}
      borderRadius="6px"
      variant="ghost"
      color={COLORS.GRAY.GRAY_600}
      _hover={{
        color: COLORS.FINCH.BLACK,
      }}
      {...props}
    />
  );
};
